import { Component, OnInit } from '@angular/core';
import { CurrencyRateService } from '../currency-rate.service';
import { Router } from '@angular/router';


export interface Pagination {
  current_page?: number;
  first_item?: number;
  first_page_url?: string;
  last_item?: number;
  last_page?: number;
  last_page_url?: string;
  next_page_url?: string;
  per_page?: number;
  prev_page_url?: string;
  total?: number;
}


@Component({
  selector: 'app-currency-rate',
  templateUrl: './currency-rate.component.html',
  styleUrls: ['./currency-rate.component.css'],
  providers: [ CurrencyRateService ]
})
export class CurrencyRateComponent implements OnInit {


	currencyRates: any = [];
  currencyTransaction: any =[];
  loading: boolean = false;
  loadingModal: boolean = false;
  pagination: Pagination;
  currencyTransactionModal : boolean = false;
  id:any="";

  constructor(private currencyRateService: CurrencyRateService, private router: Router) {
   }

  ngOnInit() {

    this.pagination = {
      current_page: 1,
      per_page: 1
    }

       this.loading= true;
       this.currencyRateService.getCurrencyRate().subscribe(response=>{this.currencyRates=response['data'];this.loading= false;});
  }

  showTransactionModal(id: any){
       this.id=id;
       this.currencyTransaction=[];
       this.currencyTransactionModal = true;
       this.getCurrencyRateHistory();
    
  }

  getCurrencyRateHistory(page:any=1){
    this.loadingModal= true;
    this.currencyRateService.getCurrencyRateHistoryById(this.id,page).subscribe(response=>{
      this.pagination = response['pagination'] || this.pagination;
      this.currencyTransaction=response['data'];
      this.loadingModal= false;
     });
  }

  onPaginate(event) {
    this.pagination.current_page=event.page + 1;
    this.getCurrencyRateHistory(this.pagination.current_page);
  }

  add(){
  	   this.router.navigate(['/dashboard/currency-rate-crud']);
  }

  edit(id: any){
       this.router.navigate(['/dashboard/currency-rate-crud/',id]);
  }
  
}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/currency_rates/currency-rate/currency-rate.component.ts